import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconText = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M14 16.5a.5.5 0 0 0 .5.5h.5a2 2 0 0 1 0 4H9a2 2 0 0 1 0-4h.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V8a2 2 0 0 1-4 0V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-4 0v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} viewBox="0 0 24 24" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconText.displayName = 'IconText';